import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectOutput } from 'core/http/dev';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { Observable } from 'rxjs';
import { Uuid } from 'shared/common/types';
import { Criteria } from 'shared/criteria/Criteria';

export interface RootSimpleExtensionOutput {
  id: Uuid;
  name: string;
  projects: ProjectOutput[];
}

@Injectable()
export class ExtensionService {
  constructor(private http: HttpClient) { }

  getAllSimpleExtensions(criteria?: Criteria): Observable<RootSimpleExtensionOutput[]> {
    return this.http.get<RootSimpleExtensionOutput[]>(apiUrl('/root/extensions/simple-extensions', criteria));
  }

  updateExtensionProjects(extensionId: string, projectsToEnabling: string[]): Observable<ProjectOutput[]> {
    return this.http.put<ProjectOutput[]>(apiUrl(`/root/extension/${extensionId}/projects`), { projectsToEnabling });
  }
}
